import React from "react"
import { TrashCan } from "./components/TrashCan"
import { AmexColourIcon } from "./components/payment-icons/Amex/AmexColourIcon"
import { ApplePayIcon } from "./components/payment-icons/ApplePay/ApplePayIcon"
import { MastercardColourIcon } from "./components/payment-icons/Mastercard/MastercardColourIcon"
import { VisaColourIcon } from "./components/payment-icons/Visa/VisaColourIcon"
import { PaypalColourIcon } from "./components/payment-icons/Paypal/PaypalColourIcon"
import { PromoCodeCoupon } from "./components/PromoCodeCoupon"
import { SuccessIcon } from "./components/Success"
import { ErrorIcon } from "./components/Error"
import { Warning } from "./components/Warning"
import { Heart } from "./components/Heart"
import { MagnifyingGlass } from "./components/MagnifyingGlass"
import { User } from "./components/User"
import { Bag } from "./components/Bag"

const icons = {
  "trash-can": TrashCan,
  "amex-colour": AmexColourIcon,
  "apply-pay": ApplePayIcon,
  "master-card-colour": MastercardColourIcon,
  "visa-colour": VisaColourIcon,
  "paypal-colour": PaypalColourIcon,
  "promo-code": PromoCodeCoupon,
  error: ErrorIcon,
  success: SuccessIcon,
  warning: Warning,
  heart: Heart,
  "magnifying-glass": MagnifyingGlass,
  user: User,
  bag: Bag,
} as const

export type IconProps = {
  icon: keyof typeof icons
  className?: string
}

export function Icon(props: IconProps): JSX.Element {
  const { icon, className = "" } = props
  const Component = icons[icon]
  return <Component className={className} />
}
